import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { ViewProps } from './ViewProps';
import styles from './SpecifiedWorks.scss';

const ORDINAL_STRING = 'イロハニホヘトチリヌルヲワカ';

const WORKS = [
  { code: 'handling_hot_objects', label: '多量の高熱物体を取り扱う業務及び著しく暑熱な場所における業務' },
  { code: 'handling_cold_objects', label: '多量の低温物体を取り扱う業務及び著しく寒冷な場所における業務' },
  { code: 'handling_harmful_radiation', label: 'ラジウム放射線、エツクス線その他の有害放射線にさらされる業務' },
  { code: 'handling_dust', label: '土石、獣毛等のじんあい又は粉末を著しく飛散する場所における業務' },
  { code: 'handling_abnormal_pressure', label: '異常気圧下における業務' },
  { code: 'handling_vibration', label: 'さく岩機、鋲打機等の使用によつて、身体に著しい振動を与える業務' },
  { code: 'handling_heavy_objects', label: '重量物の取扱い等重激な業務' },
  { code: 'handling_loud_noise', label: 'ボイラー製造等強烈な騒音を発する場所における業務' },
  { code: 'working_underground', label: '坑内における業務' },
  { code: 'night_shift', label: '深夜業を含む業務' },
  {
    code: 'handling_harmful_substances',
    label:
      '水銀、砒素、黄りん、弗化水素酸、塩酸、硝酸、硫酸、青酸、か性アルカリ、石炭酸その他これらに準ずる有害物を取り扱う業務'
  },
  {
    code: 'handling_harmful_gas',
    label:
      '鉛、水銀、クロム、砒素、黄りん、弗化水素、塩素、塩酸、硝酸、亜硫酸、硫酸、一酸化炭素、二硫化炭素、青酸、ベンゼン、アニリンその他これらに準ずる有害物のガス、蒸気又は粉じんを発散する場所における業務'
  },
  { code: 'handling_pathogens', label: '病原体によつて汚染のおそれが著しい業務' },
  { code: 'other', label: 'その他厚生労働大臣が定める業務' }
];

const findSpecifiedWork = (code: string) => {
  for (let i = 0; i < WORKS.length; i++) {
    if (WORKS[i].code === code) {
      return { ...WORKS[i], ordinal: ORDINAL_STRING[i] };
    }
  }
  return null;
};

export const SpecifiedWorks: FC<ViewProps> = ({ result, editLink }) => {
  const work = result.specifiedWorkCode ? findSpecifiedWork(result.specifiedWorkCode) : null;

  return (
    <Panel>
      <Link to={`${editLink}#specified_works`}>
        <Headding icon={<Edit icon={16} />}>労働安全衛生規則第13条第１項第３号に掲げる業務</Headding>
      </Link>
      <Item>
        <ol className={styles.list}>
          {work ? (
            <li className={styles.listItem}>
              <div>{work.ordinal}</div>
              <div>{work.label}</div>
            </li>
          ) : (
            <li>該当なし</li>
          )}
        </ol>
      </Item>
    </Panel>
  );
};
